module.exports = __webpack_public_path__ + "media/toolkits/HVAC-toolkit-header-3a053e42.jpg";